// extracted by mini-css-extract-plugin
module.exports = {"heading":"settings-table_heading__3BjJj","table":"settings-table_table__3j1JF"};